import React,{ useState } from 'react';
// import { Link } from 'gatsby'
import { Link } from 'gatsby'
import 'bootstrap/dist/css/bootstrap.min.css';
// import {NavLink} from 'react-router-dom'

const Navigation = () => {

  const [toggleMenu, setToggleMenu] = useState(false);

    return(
      <nav className="app__navbar">
        <div className="app__navbar-wrapper">
          <div className="app__navbar-logo">
            <Link className='logo' to="/" />
          </div>
          <ul className="app__navbar-links" >
            <li><Link className='navbarLinks' activeClassName="active" to="/features">Features</Link></li>
            <li><Link className='navbarLinks' activeClassName="active" to="/connectors">Connectors</Link></li>
            <li><Link className='navbarLinks' activeClassName="active" to="/pricing">Pricing</Link></li>
            <li><Link className='navbarLinks' activeClassName="active" to="/blog">Blog</Link></li>
            <li><Link to="http://eepurl.com/hSb7QD" title="Get Started Free" className="dropdownBtn" striphash>Get Started Free</Link></li>
          </ul>
        </div>
        
        <div className="app__navbar-smallscreen">
          <img src="/images/navBurgerIcon.png" alt="" onClick={() => setToggleMenu(true)} />
          {toggleMenu && (
            <div className="app__navbar-smallscreen_overlay">
              <div className="app__navbar-logo">
                <Link className='logo' to="/"/>
              </div>
              <img src="/images/closeOutIcon.png" alt="" className='overlay__close' onClick={() => setToggleMenu(false)} />
              <ul className='links'>
                <li className='navLinks' ><a href="/features">Features</a></li>
                <li className='navLinks' ><a href="/connectors">Connectors</a></li>
                <li className='navLinks' ><a href="/pricing">Pricing</a></li>
                <li className='navLinks' ><a href="/blog">Blog</a></li>
                <li><Link to="http://eepurl.com/hSb7QD" title="Get Started Free" className="dropdownBtn" striphash>Get Started Free</Link></li>
              </ul>
            </div>
          )}
        </div>
      </nav>
    )
}
export default Navigation
